import React, {useState} from 'react'
import {Box, Button, InputAdornment, MenuItem, Popover, TextField, Typography} from "@material-ui/core";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import DateRangeIcon from "@material-ui/icons/DateRange";

/**
 * Control único de rango de fechas para MUI v4 (pickers v3 no trae DateRangePicker nativo).
 * Muestra un campo "desde - hasta" que abre un popover con dos calendarios y un botón Aplicar.
 * onChange(desde, hasta) se dispara solo al aplicar.
 *
 * El calendario estático (sin toolbar) solo navega por mes, por eso se agrega un selector
 * de año propio junto a cada rótulo.
 */

// Rango de años seleccionables: desde 15 años atrás hasta el año próximo.
const THIS_YEAR = new Date().getFullYear();
const YEARS = [];
for (let y = THIS_YEAR + 1; y >= THIS_YEAR - 15; y--) YEARS.push(y);

export const DateRangeControl = ({desde, hasta, onChange, label = 'Período', className, style}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [draftDesde, setDraftDesde] = useState(desde);
    const [draftHasta, setDraftHasta] = useState(hasta);

    const open = event => {
        setDraftDesde(desde);
        setDraftHasta(hasta);
        setAnchorEl(event.currentTarget);
    };

    const close = () => setAnchorEl(null);

    const apply = () => {
        onChange(draftDesde, draftHasta);
        close();
    };

    const caption = `${desde.format('DD/MM/YYYY')} - ${hasta.format('DD/MM/YYYY')}`;

    const renderCalendar = ({title, value, setValue, minDate, maxDate}) => (
        <Box display='flex' flexDirection='column' alignItems='center'>
            <Box display='flex' alignItems='center' mb={1}>
                <Typography variant='subtitle2' style={{fontWeight: 'bold', color: '#000'}} className='mr-2'>
                    {title}
                </Typography>
                <TextField
                    select
                    value={value.year()}
                    onChange={event => setValue(value.clone().year(event.target.value))}
                    InputProps={{style: {fontWeight: 'bold'}}}
                >
                    {YEARS.map(y => (
                        <MenuItem key={y} value={y}>{y}</MenuItem>
                    ))}
                </TextField>
            </Box>
            <DatePicker
                autoOk
                disableToolbar
                variant="static"
                value={value}
                minDate={minDate}
                maxDate={maxDate}
                onChange={moment => setValue(moment)}
            />
        </Box>
    );

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <TextField
                label={label}
                className={className}
                style={{width: '15rem', ...style}}
                value={caption}
                onClick={open}
                InputProps={{
                    readOnly: true,
                    style: {cursor: 'pointer'},
                    endAdornment: (
                        <InputAdornment position="end">
                            <DateRangeIcon color="action"/>
                        </InputAdornment>
                    )
                }}
            />
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={close}
                anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                transformOrigin={{vertical: 'top', horizontal: 'left'}}
            >
                <Box display='flex' flexDirection='column' p={2}>
                    <Box display='flex'>
                        {renderCalendar({
                            title: 'Desde',
                            value: draftDesde,
                            setValue: setDraftDesde,
                            maxDate: draftHasta
                        })}
                        {renderCalendar({
                            title: 'Hasta',
                            value: draftHasta,
                            setValue: setDraftHasta,
                            minDate: draftDesde
                        })}
                    </Box>
                    <Box display='flex' justifyContent='flex-end' mt={1}>
                        <Button onClick={close} className='mr-2'>Cancelar</Button>
                        <Button onClick={apply} color='primary' variant='contained'>Aplicar</Button>
                    </Box>
                </Box>
            </Popover>
        </MuiPickersUtilsProvider>
    );
};
